module.exports = __webpack_public_path__ + "static/media/IMG-12.28cd937e.jpg";